<template>
    <i :class="`icon icon__arrow icon__arrow--${direction}`"></i>
</template>

<script>
export default {
    props: {
        direction: {
            type: String,
            validator: function (value) {
                return ['up', 'down', 'right', 'left'].indexOf(value) !== -1
            },
            default: 'down'
        }
    }
}
</script>

